<template>
  <div class="flex flex-col items-start px-0 mb-12 border-t-2 border-b-2 border-gray-100 md:flex-row container-small" :class="identity ? 'justify-start md:justify-between py-5' : ''">
    <p v-if="!identity" class="hidden md:block">{{ identitySender }}</p>
    <p v-if="identity" class="hidden md:block">{{ `${identityPrefix} ${identitySender}` }}</p>
    <div v-if="identity" class="flex flex-col md:hidden">
      <p class="mb-3">{{ identityPrefix }}</p>
      <p class="mb-5 font-futuraEfDemiBold md:font-futuraEfBook">{{ identitySender }}</p>
    </div>

    <div class="flex items-center">
      <p class="text-lg font-futuraEfDemiBold" :class="identity ? 'text-black' : 'text-green-dark'">
        {{ label }}
      </p>
      <ShareNetwork class="ml-4" rel="noreferrer" network="linkedin" :url="url" :title="title" :description="description" data-click-id="social-share-linkedin" data-click-parent="social-sharing">
        <svg width="24" height="24" class="inline" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM7.286 8.544a1.26 1.26 0 0 1 1.256-1.258 1.259 1.259 0 0 1 0 2.517 1.259 1.259 0 0 1-1.256-1.259Zm.313 1.764h1.887c.09 0 .162.073.162.163v6.08c0 .09-.073.163-.162.163H7.599a.163.163 0 0 1-.162-.162V10.47c0-.09.072-.163.162-.163Zm6.71-.071c-.691 0-1.298.21-1.668.553v-.319a.163.163 0 0 0-.163-.163h-1.81a.163.163 0 0 0-.162.163v6.08c0 .09.073.163.163.163h1.884c.09 0 .163-.073.163-.162v-3.009c0-.863.159-1.398.95-1.398.78.001.838.575.838 1.45v2.957c0 .09.072.162.162.162h1.886c.09 0 .162-.073.162-.162v-3.336c0-1.387-.273-2.98-2.406-2.98Z"
            :fill="identity === 'ellevio-energy-solutions' ? '#AAA672' : '#0A8454'" />
        </svg>
      </ShareNetwork>
      <ShareNetwork class="ml-4" rel="noreferrer" network="twitter" :url="url" :title="title" :description="description" data-click-id="social-share-twitter" data-click-parent="social-sharing">
        <svg xmlns="http://www.w3.org/2000/svg" class="inline" width="24" height="24" fill="none" viewBox="0 0 38 38">
          <path
            :fill="identity === 'ellevio-energy-solutions' ? '#AAA672' : '#0B8454'"
            fill-rule="evenodd"
            d="M19 38c10.493 0 19-8.507 19-19S29.493 0 19 0 0 8.507 0 19s8.507 19 19 19Zm-1.618-18.238L10.046 10H15.7l4.81 6.4L26.46 10h1.662l-6.872 7.388L29 27.698h-5.654l-5.221-6.949-6.463 6.95H10l7.382-7.937Zm-2.295-8.544h-2.598L23.96 26.48h2.597l-11.47-15.262Z"
            clip-rule="evenodd" />
        </svg>
      </ShareNetwork>
      <ShareNetwork class="ml-4" rel="noreferrer" network="facebook" :url="url" :title="title" :description="description" data-click-id="social-share-facebook" data-click-parent="social-sharing">
        <svg height="24" width="24" class="inline" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 38 38">
          <defs><path id="a" d="M0 0h9.329v17.665H0z" /></defs>
          <g fill="none" fill-rule="evenodd">
            <circle :fill="identity === 'ellevio-energy-solutions' ? '#AAA672' : '#0A8454'" cx="19" cy="19" r="19" />
            <g transform="translate(14 10)">
              <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
              <path d="M6.949 2.978h2.38V0h-2.38C2.19 0 2.655 4.225 2.655 4.225v2.213H0v3.22h2.655v8.007h3.299V9.658h2.777l.449-3.22H5.954V4.225c0-1.005.995-1.247.995-1.247" fill="#FFF" />
            </g>
          </g>
        </svg>
      </ShareNetwork>
      <a :href="`mailto:?subject=${title}&body=${description}%0D%0A${url}`" rel="noreferrer" class="ml-4" data-click-id="social-share-mail" data-click-parent="social-sharing">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_2687_36732" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H24V24H0V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_2687_36732)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 0C5.38294 0 0 5.38279 0 11.9997C0 18.6166 5.38294 24.0002 12 24.0002C18.6171 24.0002 24 18.6166 24 11.9997C24 5.38279 18.6171 0 12 0ZM11.9999 1.18675C17.9722 1.18675 22.8132 6.02841 22.8132 11.9997C22.8132 17.9718 17.9722 22.8126 11.9999 22.8126C6.02769 22.8126 1.18672 17.9718 1.18672 11.9997C1.18672 6.02841 6.02769 1.18675 11.9999 1.18675Z"
              :fill="identity === 'ellevio-energy-solutions' ? '#AAA672' : '#0B8454'" />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7844 15.8956L15.3161 12.2454C15.6679 11.9061 16.0588 11.5168 16.4945 11.0671C17.3788 10.1538 18.2168 9.23469 18.7844 8.59934V15.8956ZM9.62879 12.9421C11.3519 14.494 11.8536 14.4965 12.0995 14.4965C12.3462 14.4965 12.8479 14.494 14.5727 12.9404L17.8422 16.3804H6.36084L9.62879 12.9421ZM14.251 11.857C14.2493 11.8578 14.2485 11.8578 14.2477 11.8595C14.2461 11.8603 14.2461 11.8611 14.2453 11.8619C13.15 12.8832 12.3804 13.458 12.1019 13.4768C11.8234 13.458 11.0596 12.8897 9.97323 11.8791C9.96672 11.8725 9.96265 11.8652 9.95695 11.8595C9.9488 11.8513 9.93903 11.8464 9.93089 11.839C8.84944 10.8292 7.45448 9.38922 5.8999 7.61975H18.2991C16.7355 9.39985 15.334 10.8463 14.251 11.857ZM5.41455 8.59934C5.98215 9.23469 6.81929 10.1538 7.70448 11.0671C8.14096 11.5177 8.53266 11.9077 8.88527 12.2479L5.41455 15.9005V8.59934ZM18.6061 6.6001H5.59373C4.93492 6.6001 4.3999 7.13814 4.3999 7.79883V16.2014C4.3999 16.8621 4.93492 17.4001 5.59373 17.4001H18.6061C19.2641 17.4001 19.7999 16.8621 19.7999 16.2014V7.79883C19.7999 7.13814 19.2641 6.6001 18.6061 6.6001Z"
            :fill="identity === 'ellevio-energy-solutions' ? '#AAA672' : '#0B8454'" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import { ShareNetwork } from 'vue-social-sharing'

export default {
  name: 'EllevioWebShareOnSocialMedia',
  components: {
    ShareNetwork
  },
  props: {
    label: {
      type: String,
      default: 'Dela:'
    },
    title: {
      type: String,
      default: 'Delat från Ellevio.se'
    },
    description: {
      type: String,
      default: 'Delat från Ellevio.se'
    },
    identity: {
      type: String,
      default: ''
    },
    identitySender: {
      type: String,
      default: ''
    },
    identityPrefix: {
      type: String,
      default: 'Information från:'
    }
  },
  computed: {
    url() {
      return window.location.href
    }
  }
}
</script>
